import {styled} from '../theme-provider';

export const FadeInOutViewContainer = styled.div`
  transition: 0.3s;
`;
